module.exports = __webpack_public_path__ + "img/organization-img_2--mobile.97c63aa.jpg";